import { apiService } from './api.js'
import { ANALYTICS_EVENTS } from '@/constants/analyticsEvents.ts'
import analytics from '@/services/analytics.ts'

export const setupService = {
    async fetchSetups() {
        return apiService.get('/api/v1/dart-setups')
    },

    async createSetup(data) {
        return apiService.post('/api/v1/dart-setups', data)
    },

    async updateSetup(id, data) {
        return apiService.put(`/api/v1/dart-setups/${id}`, data)
    },

    async deleteSetup(id) {
        return apiService.delete(`/api/v1/dart-setups/${id}`)
    },

    async searchProducts(query, type) {
        const params = new URLSearchParams()
        if (query) {
            params.append('q', query)
        }
        if (type) {
            params.append('type', type)
        }
        const queryString = params.toString()
        const response = await apiService.get(
            `/api/v1/products/search${queryString ? `?${queryString}` : ''}`,
        )

        // Only a typed search is a user action - this is also called with an empty query to list
        // a component's products, which is a page load, not a search.
        //
        // The query itself is never sent: it is free text a user typed, so only its length goes
        // out. A search that returns nothing is the interesting case, since that is a gap in the
        // catalogue rather than a user who couldn't be bothered.
        if (query) {
            analytics.trackEvent(ANALYTICS_EVENTS.PRODUCT_SEARCHED, {
                query_len: query.trim().length,
                product_type: type || null,
                result_count: response?.data?.length ?? 0,
            })
        }

        return response
    },

    async saveExternalProduct(product) {
        return apiService.post('/api/v1/products/save-external', {
            id: product.id,
            external_id: product.external_id || product.id,
            name: product.name,
            sku: product.sku,
            slug: product.slug,
            type: product.type,
            image_url: product.image_url,
            description: product.description,
            price: product.price,
        })
    },
}
